/*
 * @Author: 邓宇芩 707208431@qq.com
 * @Date: 2025-11-17 11:27:24
 * @LastEditors: 邓宇芩 707208431@qq.com
 * @LastEditTime: 2025-12-15 09:50:17
 * @FilePath: \scanqrcode\src\locales\zh-TW.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  languageLabel: "語言",
  languageOptions: {
    en: "English",
    zh_CN: "簡體中文",
    zh_TW: "繁體中文",
  },
  scannerNameLabel: "QR Code 掃描器名稱",
  scannerNamePlaceholder: "請輸入 QR Code 掃描器名稱",
  passwordLabel: "密碼",
  passwordPlaceholder: "請輸入密碼...",
  loginButton: "登入",
  enterButton: "進入",
  toastFillFields: "請填寫完整資訊",
  toastLoginFailed: "登入失敗",
  indexEventTitle: "2025 HowZ 台北演唱會",
  indexStatsTotal: "總紀錄",
  indexStatsCheckedIn: "已報到",
  indexStatsPending: "待報到",
  indexSearchPlaceholder: "搜尋...",
  indexStatusFilters: {
    all: "全部",
    claimed: "已報到",
    unclaimed: "未報到",
  },
  indexTableHeaders: {
    name: "姓名",
    email: "電子郵件",
    checkInTime: "報到時間",
    status: "狀態",
  },
  indexEmpty: "沒有找到結果。",
  indexPaginationPrev: "上一頁",
  indexPaginationNext: "下一頁",
  indexPaginationPage: "第",
  indexPaginationOf: "頁，共",
  indexScanButton: "掃描 QR Code",
  indexStatusLabels: {
    claimed: "已簽到",
    unclaimed: "未簽到",
  },
  indexDetailTitle: "詳情",
  indexDetailName: "姓名:",
  indexDetailEmail: "電子郵件:",
  indexDetailCheckInTime: "簽到時間:",
  indexDetailStatus: "狀態:",
  indexDetailClose: "關閉",
  readerDetailItemHolder: "持有人:",
  readerDetailItemName: "商品名稱:",
  readerDetailOrderItems: "商品明細:",
  readerDetailVariantDetails: "規格:",
  readerDetailEmailAddress: "電子郵件地址:",
  readerDetailCheckInTime: "簽到時間:",
  readerModalClose: "關閉",
};
